import {
  balanceSheetBankingRows,
  balanceSheetMappingBanking,
} from './balance-sheeet/BankingConst';
import {
  balanceSheetCKChartTitles,
  BalanceSheetCKRows,
  CKMapping as BSCKMapping,
} from './balance-sheeet/CKConst';

import {
  balanceSheetChartBankingTitles,
  balanceSheetChartTitles,
  balanceSheetMapping,
  balanceSheetRows,
} from './balance-sheeet/Const';
import {
  balanceSheetInsuranceChartTitles,
  BSInsuranceRows,
  InsuranceMapping,
} from './balance-sheeet/InsuranceConst';
import { cashFlowStatementBankingRows } from './cash-flow-statement/BankingConst';
import { CFCKRows } from './cash-flow-statement/CKConst';
import { cashFlowStatementRows } from './cash-flow-statement/Const';
import { CFBHRows } from './cash-flow-statement/InsuranceConst';
import { CKMapping as CFCKMapping } from './cash-flow-statement/CKConst';
import { TYPES } from './Const';
import { incomeStatementBankingRows } from './income-statement/BankingConst';
import { ISCKRows, CKMapping } from './income-statement/CKConst';
import {
  incomeStatementMapping,
  incomeStatementRows,
} from './income-statement/Const';
import {
  incomeStatementInsuranceMapping,
  insuranceRows,
} from './income-statement/InsuranceConst';

const getKey = item => `${item.quarterReport}_${item.yearReport}`;

const getNonBankingData = item => {
  const otherAssets =
    item[balanceSheetMapping.totalAssets] -
    item[balanceSheetMapping.currentAssets] -
    item[balanceSheetMapping.tangibleFixedAssets] -
    item[balanceSheetMapping.intangibleFixedAssets];

  return {
    [getKey(item)]: {
      otherAssets,
      currentAssets: item[balanceSheetMapping.currentAssets],
      tangibleFixedAssets: item[balanceSheetMapping.tangibleFixedAssets],
      intangibleFixedAssets: item[balanceSheetMapping.intangibleFixedAssets],
      currentLiabilities: item[balanceSheetMapping.currentLiabilities],
      longTermLiabilities: item[balanceSheetMapping.longTermLiabilities],
      shareholderEquity: item[balanceSheetMapping.ownerEquity],
      minorityInterest: item[balanceSheetMapping.minorityInterest],
      total: item.bsa53,
    },
  };
};

const getCkData = item => {
  const otherAssets =
    item[BSCKMapping.totalAssets] -
    item[BSCKMapping.currentAssets] -
    item[BSCKMapping.tangibleFixedAssets] -
    item[BSCKMapping.intangibleFixedAssets];

  return {
    [getKey(item)]: {
      otherAssets,
      currentAssets: item[BSCKMapping.currentAssets],
      tangibleFixedAssets: item[BSCKMapping.tangibleFixedAssets],
      intangibleFixedAssets: item[BSCKMapping.intangibleFixedAssets],
      currentLiabilities: item[BSCKMapping.currentLiabilities],
      longTermLiabilities: item[BSCKMapping.longtermLiabilities],
      shareholderEquity: item[BSCKMapping.ownersEquity],
      minorityInterestBefore: item[BSCKMapping.minorityInterestBefore],
      total: item.bsa53,
    },
  };
};

const getInsuranceData = item => {
  const otherAssets =
    item[InsuranceMapping.totalAssets] -
    item[InsuranceMapping.currentAssets] -
    item[InsuranceMapping.tangibleFixedAssets] -
    item[InsuranceMapping.intagibleFixedAssets] -
    item[InsuranceMapping.loansAndAdvancesToCustomersOne];

  const otherLiabilites =
    item[InsuranceMapping.liabilities] -
    item[InsuranceMapping.currentLiabilities] -
    item[InsuranceMapping.longtermLiabilites];

  return {
    [getKey(item)]: {
      otherAssets,
      otherLiabilites,
      currentAssets: item[InsuranceMapping.currentAssets],
      loansAndAdvancesToCustomersOne:
        item[InsuranceMapping.loansAndAdvancesToCustomersOne],
      tangibleFixedAssets: item[InsuranceMapping.tangibleFixedAssets],
      intagibleFixedAssets: item[InsuranceMapping.intagibleFixedAssets],
      currentLiabilities: item[InsuranceMapping.currentLiabilities],
      longtermLiabilites: item[InsuranceMapping.longtermLiabilites],
      shareholderEquity: item[InsuranceMapping.ownersEquity],
      minorityInterestBefore: item[InsuranceMapping.minorityInterestBefore],
      total: item.bsa53,
    },
  };
};

const getBankingData = item => {
  const otherAssets =
    item[balanceSheetMappingBanking.totalAssets] -
    item[
      balanceSheetMappingBanking.placementsWithAndLoansToOtherCreditInstitutions
    ] -
    item[balanceSheetMappingBanking.loansAndAdvancesToCustomersNet] -
    item[balanceSheetMappingBanking.investmentSecurities];

  const otherLiabilities =
    item[balanceSheetMappingBanking.totalLiabilities] -
    item[balanceSheetMappingBanking.depositsFromCustomers];

  return {
    [getKey(item)]: {
      otherAssets,
      otherLiabilities,
      placementsLoanToCreditInstitutions:
        item[
          balanceSheetMappingBanking
            .placementsWithAndLoansToOtherCreditInstitutions
        ],
      loansAdvancesToCustomers:
        item[balanceSheetMappingBanking.loansAndAdvancesToCustomersNet],
      investmentSecurities:
        item[balanceSheetMappingBanking.investmentSecurities],
      depositsFromCustomers:
        item[balanceSheetMappingBanking.depositsFromCustomers],
      shareholderEquity: item[balanceSheetMappingBanking.shareholderEquity],
      minorityInterest: item[balanceSheetMappingBanking.minorityInterest],
      total: item.bsa53,
    },
  };
};

export const removeNullItem = data => {
  const obj = {};
  Object.keys(data).forEach(key => {
    obj[key] = data[key] || 0;
  });

  return obj;
};

const getChartData = (row, data, comTypeCode) => {
  const mapChartTitle = {
    NH: balanceSheetChartBankingTitles,
    BH: balanceSheetInsuranceChartTitles,
    CK: balanceSheetCKChartTitles,
  };

  if (!data.length) {
    return {
      ...row,
      titles: mapChartTitle[comTypeCode] || balanceSheetChartTitles,
    };
  }

  const mapFunc = {
    NH: getBankingData,
    BH: getInsuranceData,
    CK: getCkData,
  };

  const getItemFunc = mapFunc[comTypeCode] || getNonBankingData;

  const extraData = data.reduce(
    (result, item) => ({
      ...result,
      ...getItemFunc(item),
      titles: mapChartTitle[comTypeCode] || balanceSheetChartTitles,
    }),
    {},
  );

  return { ...row, ...extraData };
};

const formatBalanceSheetItem = (data, comTypeCode, ignoreIds = []) => {
  const mapComtypeCode = {
    NH: balanceSheetBankingRows,
    BH: BSInsuranceRows,
    CK: BalanceSheetCKRows,
  };
  const rows = mapComtypeCode[comTypeCode] || balanceSheetRows;

  const formattedData = rows.reduce(
    (final, row) => {
      const ids = ignoreIds.includes(row.id)
        ? final.ids
        : final.ids.concat(row.id);
      if (row.type === TYPES.CHART) {
        return {
          ...final,
          ids,
          dataByIds: {
            [row.id]: getChartData(row, data, comTypeCode),
          },
        };
      }
      const extraField = data.reduce((result, item) => {
        return {
          ...result,
          [getKey(item)]: item[row.id],
        };
      }, {});

      return {
        ...final,
        ids,
        dataByIds: {
          ...final.dataByIds,
          [row.id]: { ...row, ...extraField },
        },
      };
    },
    {
      ids: [],
      dataByIds: {},
    },
  );

  return {
    ...formattedData,
    fields: getDynamicField(data),
  };
};

const getCurrentQuarter = () => {
  const now = new Date();
  const year = now.getFullYear();
  const quarter = Math.ceil(now.getMonth() / 3);

  return {
    quarter,
    year,
    key: `${quarter}_${year}`,
  };
};

const getField = (quarter, year) => ({
  quarter,
  year,
  key: `${quarter}_${year}`,
});

const fillField = data => {
  const yearlyQuarter = 5;
  const isYearly = data[0].quarterReport === yearlyQuarter;
  const first = data[0];
  const last = data[data.length - 1];
  if (isYearly) {
    const fields = [];
    for (let i = last.yearReport; i <= first.yearReport; i++) {
      fields.push(getField(yearlyQuarter, i));
    }

    return fields;
  }

  const fields = [];
  for (let i = last.yearReport; i <= first.yearReport; i++) {
    let end = 4;
    let start = 1;
    if (i === first.yearReport) {
      end = first.quarterReport;
    }
    if (i === last.yearReport) {
      start = last.quarterReport;
    }
    for (let j = start; j <= end; j++) {
      fields.push(getField(j, i));
    }
  }

  return fields;
};

export const getDynamicField = data => {
  if (data.length === 0) {
    return [getCurrentQuarter()];
  }

  if (data.length === 1) {
    return [
      {
        quarter: data[0].quarterReport,
        year: data[0].yearReport,
        key: getKey(data[0]),
      },
    ];
  }

  return fillField(data);
};

export const formatBalanceSheetData = (data, comTypeCode) => {
  return Object.keys(data).reduce((result, key) => {
    return {
      ...result,
      [key]: formatBalanceSheetItem(data[key], comTypeCode),
    };
  }, {});
};

export const formatItem = (data, rows, ignoreIds = []) => {
  const formattedData = rows.reduce(
    (result, row) => {
      const ids = ignoreIds.includes(row.id)
        ? result.ids
        : result.ids.concat(row.id);
      const extraField = data.reduce((result, item) => {
        let value = item[row.id];
        if (row.id === CFCKMapping.operatingProfitlossBeforeChangesInWc) {
          value =
            item[CFCKMapping.netProfitlossBeforeTax] +
            item[CFCKMapping.adjustment] +
            item[CFCKMapping.increaseInNoncashExpense] +
            item[CFCKMapping.decreaseInNoncashRevenue];
        }
        return {
          ...result,
          [getKey(item)]: value,
        };
      }, {});

      return {
        ...result,
        ids,
        dataByIds: {
          ...result.dataByIds,
          [row.id]: { ...row, ...extraField },
        },
      };
    },
    {
      ids: [],
      dataByIds: {},
    },
  );

  return {
    ...formattedData,
    fields: getDynamicField(data),
  };
};

export const formatIncomeStatementData = (data, comTypeCode) => {
  const rowMap = {
    NH: incomeStatementBankingRows,
    BH: insuranceRows,
    CK: ISCKRows,
  };
  const ignoreIdsMap = {
    NH: [incomeStatementMapping.netProfitMargin],
    BH: [
      incomeStatementInsuranceMapping.netProfit,
      incomeStatementInsuranceMapping.netProfitMargin,
    ],
    CK: [CKMapping.netProfitMargin],
  };
  const rows = rowMap[comTypeCode] || incomeStatementRows;
  const ignoreIds = ignoreIdsMap[comTypeCode] || [
    incomeStatementMapping.netProfitMargin,
  ];

  return Object.keys(data).reduce((result, key) => {
    return {
      ...result,
      [key]: formatItem(data[key], rows, ignoreIds),
    };
  }, {});
};

export const formatCashFlowStatementData = (data, comTypeCode) => {
  const rowMap = {
    NH: cashFlowStatementBankingRows,
    BH: CFBHRows,
    CK: CFCKRows,
  };
  const rows = rowMap[comTypeCode] || cashFlowStatementRows;

  return Object.keys(data).reduce(
    (result, key) => ({
      ...result,
      [key]: formatItem(data[key], rows),
    }),
    {},
  );
};

export const getNumberColumn = width => {
  if (width > 1100) {
    return 9;
  }

  if (width > 1000 && width <= 1100) {
    return 8;
  }

  if (width <= 1000 && width > 900) {
    return 7;
  }

  if (width <= 900 && width > 800) {
    return 6;
  }

  if (width <= 800 && width > 700) {
    return 5;
  }

  if (width <= 700 && width > 600) {
    return 4;
  }

  if (width <= 600 && width > 500) {
    return 3;
  }

  return 2;
};
